import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import {Heart, Home, NotepadText, Search, UserRound} from "lucide-react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {isAdmin, isCourier, isSupplier} from "../../../../config/Permissions";
import {getDefaultIndustry} from "../../../../config/industries";

function BottomNav({classes,global_menu,setting}) {
    const location = useLocation();
    const [value, setValue] = React.useState(location.pathname);
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        navigate(newValue);
        setValue(newValue);
    };
    const { t } = useTranslation();
    const defaultIndustry = getDefaultIndustry(setting);
    const searchIndustry = global_menu === "markets" || global_menu === "restaurants"
        ? global_menu
        : defaultIndustry;
    let orders_slug = "/account/my-orders";
    if(isAdmin()){
        orders_slug = "/panel/manage/orders";
    }else if(isSupplier()){
        orders_slug = "/panel/vendor/orders";
    }else if(isCourier()){
        orders_slug = '/account/courier-orders';
    }
    return (
        <BottomNavigation className={classes.bottomNav} value={value} onChange={handleChange}>
            <BottomNavigationAction
                label={t('home')}
                value="/"
                icon={<Home className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('search')}
                value={`/${searchIndustry}/search`}
                icon={<Search className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('orders')}
                value={orders_slug}
                icon={<NotepadText className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('wishlist')}
                value="/wishlist"
                icon={<Heart className="lucide-large"/>}
            />
            <BottomNavigationAction
                label={t('account')}
                value="/account/details"
                icon={<UserRound className="lucide-large"/>}
            />
        </BottomNavigation>
    );
}
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    global_menu: state.global_menu,
    setting: state.setting,

});
export default withStyles(Styles)(connect(mstp)(BottomNav));
